import { ReactElement } from 'react';
import { ImportAnnotationsButtonContainer } from './buttons/ImportAnnotationsButton.container';
import { ImportAnnotationsStepsContainer } from './steps/ImportAnnotationsSteps.container';

export const ImportAnnotationsView = (): ReactElement => (
  <>
    <ImportAnnotationsButtonContainer />
    <ImportAnnotationsStepsContainer />
  </>
);
